import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "../views/Login.vue"
import Programma from "../views/Programma.vue"
import ProgrammaEdit from "../views/ProgrammaEdit.vue"
import ProgrammaExtraInterno from "../views/ProgrammaExtraInterno.vue"
import ProgrammaExtraEsterno from "../views/ProgrammaExtraEsterno.vue"
import Congregazioni from "../views/Congregazioni.vue"
import Congregazione from "../views/Congregazione.vue"
import Circoscrizioni from "../views/Circoscrizioni.vue"
import Circoscrizione from "../views/Circoscrizione.vue"
import Oratori from "../views/Oratori.vue"
import Oratore from "../views/Oratore.vue"
import Schemi from "../views/Schemi.vue"
import Schema from "../views/Schema.vue"
import Ricerche from "../views/Ricerche.vue"
import Statistiche from "../views/Statistiche.vue"
import Impostazioni from "../views/Impostazioni.vue"
import NuovaCircoscrizione from "../views/NuovaCircoscrizione.vue"
import RecuperoCredenziali from "../views/RecuperoCredenziali.vue"
import AdminRealmView from "../views/AdminRealmView.vue"

Vue.use(VueRouter)

export default new VueRouter({
    routes: [
        {
            path: "/",
            name: "programma", // Ora la pagina iniziale è "programma"
            component: Programma
        },
        {
            path: "/login",
            name: "login",
            component: Login
        },      
        {
            path: "/congregazioni",
            name: "congregazioni",
            component: Congregazioni
        },
        {
            path: "/congregazione/:id",
            name: "congregazione",
            component: Congregazione,
            props: true        
        },
        {
            path: "/circoscrizioni",
            name: "circoscrizioni",
            component: Circoscrizioni
        },
        {
            path: "/circoscrizione",
            name: "circoscrizione",
            component: Circoscrizione
        },
        {
            path: "/oratori",
            name: "oratori",
            component: Oratori
        },
        {
            path: "/oratore/:id",
            name: "oratore",
            component: Oratore
        },
        {
            path: "/oratori/:idCongregazione/:nome",
            name: "oratori-congregazione",
            component: Oratori
        },
        {
            path: "/schemi",
            name: "schemi",
            component: Schemi
        },
        {
            path: "/schema/:id",
            name: "schema",
            component: Schema,
            props: true
        },        
        {
            path: "/ricerche",
            name: "ricerche",
            component: Ricerche
        },
        {
            path: "/statistiche",
            name: "statistiche",
            component: Statistiche
        },
        {
            path: "/impostazioni",
            name: "impostazioni",
            component: Impostazioni
        },
         {
            path: '/nuova-circoscrizione',
            name: 'nuova-circoscrizione',
            component: NuovaCircoscrizione
        },
        {
            path: '/recupero-credenziali',
            name: 'recupero-credenziali',
            component: RecuperoCredenziali
        },
        {
            path: '/programma/new',
            name: 'programma-new',
            component: ProgrammaEdit
        },
        {
            path: '/programma-edit/:tipo/:id',
            name: 'programma-edit',
            component: ProgrammaEdit,
            props: true
        },
        {
            path: '/programma-extra-esterno/:id?',
            name: 'programma-extra-esterno',
            component: ProgrammaExtraEsterno,
            props: true // Permette di passare l'ID come prop
        },
        {
            path: '/programma-extra-interno/:id?',
            name: 'programma-extra-interno',
            component: ProgrammaExtraInterno,
            props: true // Permette di passare l'ID come prop
        },
        {
            path: '/admin',
            name: 'admin',
            component: AdminRealmView
        },
        {
            path: '*',
            redirect: '/statistiche'
        }
    ],
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})